import request from '@/utils/request'

export const factoryApi = {
  list(data) {
    return request({
      url: '/inventory-management-api/factory/list',
      method: 'POST',
      data
    })
  },

  detail(id) {
    return request({
      url: '/inventory-management-api/factory/detail',
      method: 'POST',
      data: { id }
    })
  },

  create(data) {
    return request({
      url: '/inventory-management-api/factory/create',
      method: 'POST',
      data
    })
  },

  update(data) {
    return request({
      url: '/inventory-management-api/factory/update',
      method: 'POST',
      data
    })
  },

  delete(id) {
    return request({
      url: '/inventory-management-api/factory/delete',
      method: 'POST',
      data: { id }
    })
  },

  all() {
    return request({
      url: '/inventory-management-api/factory/all',
      method: 'POST',
      data: {}
    })
  }
}
